const CONFIG = {
  css: {
    class: 'button',
  },
  size: {
    xSmall: 'x-small',
    small: 'small',
    medium: 'medium',
    large: 'large',
    xLarge: 'x-large',
  },
  variant: {
    default: 'default',
    primary: 'primary',
    primaryLight: 'primary-light',
    primaryMedium: 'primary-medium',
    secondary: 'secondary',
    secondaryLight: 'secondary-light',
    simpleWithIcon: 'simple-with-icon',
    smallLight: 'small-light',
    whiteLight: 'white-light',
  },
};

export default CONFIG;
